import React, { useState } from 'react';
import finalLogo from '../../assets/images/final-logo.svg';
import Button from '../../components/shared/Button';
// import questionIcon from '../../assets/icons/question.svg';
import Modal from '../../components/modals/modal';
import emailSentSuccess from '../../assets/icons/emailSentSuccess.svg';
import { useNavigate } from 'react-router-dom';
import { AdminService } from '../../services';
import { Toast } from '../../components/shared/Toast';

const styles = {
	section: 'flex items-center justify-center min-h-screen bg-bgColor',
	imageStyle: 'h-12 w-[260px] mb-20',
	mainHeading: 'text-left text-main leading-39 font-semibold text-dark-blue mb-3',
	subHeading: 'text-left text-lg leading-100 text-gray mb-[50px] font-medium',
	emailLabel: 'block text-base leading-100 font-medium text-dark-blue  text-left',
	emailInput:
		'w-full pl-3.5 py-3.5 border-1p3 mt-3 border-lightGrey rounded-10p placeholder-gray-400'
};

const AdminForgotPasswordPage = () => {
	const [email, setEmail] = useState('');
	const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(false);

	const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
	const isFormValid = isValidEmail(email.trim());

	const handleSubmit = async (e) => {
		e.preventDefault();
		setIsLoading(true);
		try {
			const trimmedEmail = email.trim();
			if (!isValidEmail(trimmedEmail)) {
				Toast.error('Please enter a valid email address (e.g.,name@email.com).');
				return;
			}

			const response = await AdminService.sendResetPasswordEmail(email);
			if (response.status === 200) {
				setIsSuccessModalOpen(true);
			} else if (response.status === 404) {
				Toast.error('No account found with this email');
			} else {
				Toast.error(response.message || 'Failed to send reset password email');
			}
		} catch (error) {
			Toast.error('Network error. Please try again.');
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className={styles.section}>
			<div className="w-full max-w-md lg:w-[520px] lg:h-[645px] flex flex-col justify-center">
				<div className="mb-20">
					<svg
						className="cursor-pointer"
						width="40"
						height="40"
						viewBox="0 0 40 40"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						onClick={() => navigate('/admin/login')}
					>
						<path
							d="M19.0625 31.25L7.8125 20L19.0625 8.75M9.375 20H32.1875"
							stroke="#180A63"
							strokeWidth="3.75"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</div>
				<div>
					<img className={styles.imageStyle} src={finalLogo} alt="WriteForm Logo" />
					<h2 className={styles.mainHeading}>Forgot your password?</h2>
					<p className={styles.subHeading}>No worries — enter your email to reset it.</p>
				</div>
				<form className="" onSubmit={handleSubmit}>
					<div className="mb-[60px]">
						<div className="flex items-center gap-2 mb-2">
							<label htmlFor="email-address" className={styles.emailLabel}>
								Email Address <span className="text-red-500">*</span>
							</label>
							{/* <img src={questionIcon} alt="help icon" className="w-4 h-4" /> */}
						</div>

						<input
							id="email-address"
							name="email"
							type="email"
							autoComplete="email"
							required
							className={styles.emailInput}
							placeholder="Email Address *"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
						/>
					</div>

					<div>
						<Button type="submit" disabled={isLoading || !isFormValid} variant="default">
							{isLoading ? 'Sending...' : 'Send Email'}
						</Button>
					</div>
				</form>
			</div>
			{/* Success Modal */}
			<Modal
				isOpen={isSuccessModalOpen}
				onClose={() => setIsSuccessModalOpen(false)}
				icon={<img src={emailSentSuccess} alt="Email Sent Success" className="mx-auto" />}
				heading="Email Sent Successfully"
				description="We have sent you reset password instruction on your email."
				buttonText="Got it"
				onButtonClick={() => {
					setIsSuccessModalOpen(false);
					navigate('/admin/login');
				}}
			/>
		</div>
	);
};

export default AdminForgotPasswordPage;
